import React, {useState, useEffect, useCallback, useContext} from 'react';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { AuthContext } from "../../Header/auth - context";
import Troskovi from './TabsObracun/Troskovi'
import Dnevnice from './TabsObracun/Dnevnice'
import PuniPrazniKM from './TabsObracun/PuniPrazniKM';
import PotrosnjaGoriva from './TabsObracun/PotrosnjaGoriva';
import DodatniObracun from './TabsObracun/DodatniObracun';
import SaTelefonaTab from './TabsObracun/SaTelefonaTab';

const ObracunTure = () => {
  const { t } = useTranslation();
    const auth = useContext(AuthContext);
    const trip = useSelector(state => state.trip);

    const [changeView, setChangeView] = useState(1);
    const activeClass = 'activeButton'

    /* Troškovi koje su vozači poslali sa telefona. Lista stoji OVDE, a ne u
       Troškovima, da bi značka na tabu bila tačna i kad je otvoren drugi tab —
       trošak koji čeka obradu mora da „visi" dok ga operater ne reši. */
    const [vozacTroskovi, setVozacTroskovi] = useState([]);

    const osveziVozacTroskove = useCallback(async () => {
        if (!trip) { setVozacTroskovi([]); return; }
        try {
            const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/trip/VozacTroskovi', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
                body: JSON.stringify({ id_putni_nalog: trip }),
            });
            if (!res.ok) throw res;
            const d = await res.json();
            setVozacTroskovi(Array.isArray(d) ? d : []);
        } catch {
            /* Značka je dodatna informacija — ako se ne učita, obračun ture mora
               da radi dalje bez poruke o grešci na ekranu. */
            setVozacTroskovi([]);
        }
    }, [trip, auth.token]);

    useEffect(() => { osveziVozacTroskove(); }, [osveziVozacTroskove]);

    const visiBroj = (vozacTroskovi || []).filter(r => Number(r.statusObrade) === 0).length;

    return(
        <div className="obracun_ture">
            <Button id={changeView == 1 && activeClass} label={t('ture.troskovi')} className="mt-3 zaposleniShift" onClick={()=> {setChangeView(1)} }>
                {visiBroj > 0 && (
                    <Badge value={visiBroj} severity="warning" className="ml-2"
                           data-pr-tooltip={t('saTelefona.visiTooltip')} />
                )}
            </Button>
            <Button id={changeView == 2 && activeClass} label={t('ture.dnevnice')} className="mt-3 zaposleniShift" onClick={()=> {setChangeView(2)} } />
            <Button id={changeView == 3 && activeClass} label={t('ture.puniPrazni')} className="mt-3 zaposleniShift" onClick={()=> {setChangeView(3)} } />
            <Button id={changeView == 4 && activeClass} label={t('ture.potrosnjaGoriva')} className="mt-3 zaposleniShift" onClick={()=> {setChangeView(4)} } />
            <Button id={changeView == 5 && activeClass} label={t('ture.dodatniObracun')} className="mt-3 zaposleniShift" onClick={()=> {setChangeView(5)} } />
            <Button id={changeView == 6 && activeClass} label={t('saTelefona.tab')} className="mt-3 zaposleniShift" onClick={()=> {setChangeView(6)} } />
            <div style={{margin: "1%"}}>
                {changeView == 1 &&  <Troskovi vozacTroskovi={vozacTroskovi} osveziVozacTroskove={osveziVozacTroskove} />}
                {changeView == 2 && <Dnevnice/>}
                {changeView == 3 &&  <PuniPrazniKM/>}
                {changeView == 4 && <PotrosnjaGoriva/>}
                {changeView == 5 && <DodatniObracun/>}
                {changeView == 6 && <SaTelefonaTab/>}
            </div>
        </div>

    )
}
export default ObracunTure;
